/** Generated by @gh/common callable client codegen. Do not edit manually. */

import type { CallableApiConfig, RouteTypeMap } from "@gh/common/callable-client";
import type { AdminBackfillCustomerAdminListIndexRequest, AdminBackfillCustomerAdminListIndexResponse, ConfirmSponsorshipEligibilityRequest, ConfirmSponsorshipEligibilityResponse, ConsultantUpsertRequest, ConsultantUpsertResponse, CreatePasswordRecoveryBridgeRequest, CreatePasswordRecoveryBridgeResponse, CreateReferralProgram, CreateSystemUserRequest, CreateSystemUserResponse, CustomerAuthStatusResponse, DeleteSystemUserRequest, DeleteSystemUserResponse, EditCustomerTrialDatesRequest, EmptyRequest, EndStaffSessionResponse, GenerateCustomTokenRequest, GenerateCustomTokenResponse, GetCustomerAuthStatusRequest, GetSystemUserByEmailRequest, GetSystemUserByUidRequest, GetSystemUserResponse, GetUserCustomClaimsRequest, GetUserCustomClaimsResponse, PreviewSponsorshipEligibilityRequest, PreviewSponsorshipEligibilityResponse, ReactivateSystemUserRequest, RecalcSponsorEvaluationForCustomerRequest, RecalcSponsorEvaluationForCustomerResponse, RedeemPasswordRecoveryBridgeRequest, RedeemPasswordRecoveryBridgeResponse, RefreshPaymentMethodInputsForCustomerRequest, RefreshPaymentMethodInputsForCustomerResponse, RegeneratePasswordRecoveryBridgeRequest, RevokeCustomerSessionsRequest, RevokePasswordRecoveryBridgeRequest, SendClassScheduleNotificationRequest, SendNotificationResponse, SetCustomerAuthDisabledRequest, SetCustomerDeveloperAccountRequest, SetCustomerDeveloperAccountResponse, SponsorInfoEditEndDateRequest, SuccessMessageResponse, SuccessOnlyResponse, SyncCustomerToCustomerIoRequest, SyncCustomerToCustomerIoResponse, TriggerEvidenceDeployResponse, UpdateCustomerEmailRequest, UpdateSystemUserRequest, UpdateUserCustomClaimsRequest } from "../../src/types";



export interface AdminRouteTypeMap extends RouteTypeMap {
  backfillCustomerAdminListIndex: {
    request: AdminBackfillCustomerAdminListIndexRequest;
    response: AdminBackfillCustomerAdminListIndexResponse;
  };
  confirmSponsorshipEligibility: {
    request: ConfirmSponsorshipEligibilityRequest;
    response: ConfirmSponsorshipEligibilityResponse;
  };
  createPasswordRecoveryBridge: {
    request: CreatePasswordRecoveryBridgeRequest;
    response: CreatePasswordRecoveryBridgeResponse;
  };
  createReferralProgram: {
    request: CreateReferralProgram;
    response: SuccessMessageResponse;
  };
  createSystemUser: {
    request: CreateSystemUserRequest;
    response: CreateSystemUserResponse;
  };
  deleteSystemUser: {
    request: DeleteSystemUserRequest;
    response: DeleteSystemUserResponse;
  };
  editCustomerTrialDates: {
    request: EditCustomerTrialDatesRequest;
    response: SuccessMessageResponse;
  };
  endStaffSession: {
    request: EmptyRequest;
    response: EndStaffSessionResponse;
  };
  generateCustomToken: {
    request: GenerateCustomTokenRequest;
    response: GenerateCustomTokenResponse;
  };
  generateCustomTokenForCustomer: {
    request: EmptyRequest;
    response: GenerateCustomTokenResponse;
  };
  getCustomerAuthStatus: {
    request: GetCustomerAuthStatusRequest;
    response: CustomerAuthStatusResponse;
  };
  getSystemUserByEmail: {
    request: GetSystemUserByEmailRequest;
    response: GetSystemUserResponse;
  };
  getSystemUserByUid: {
    request: GetSystemUserByUidRequest;
    response: GetSystemUserResponse;
  };
  getUserCustomClaims: {
    request: GetUserCustomClaimsRequest;
    response: GetUserCustomClaimsResponse;
  };
  previewSponsorshipEligibility: {
    request: PreviewSponsorshipEligibilityRequest;
    response: PreviewSponsorshipEligibilityResponse;
  };
  reactivateSystemUser: {
    request: ReactivateSystemUserRequest;
    response: SuccessMessageResponse;
  };
  recalcSponsorEvaluationForCustomer: {
    request: RecalcSponsorEvaluationForCustomerRequest;
    response: RecalcSponsorEvaluationForCustomerResponse;
  };
  redeemPasswordRecoveryBridge: {
    request: RedeemPasswordRecoveryBridgeRequest;
    response: RedeemPasswordRecoveryBridgeResponse;
  };
  refreshPaymentMethodInputsForCustomer: {
    request: RefreshPaymentMethodInputsForCustomerRequest;
    response: RefreshPaymentMethodInputsForCustomerResponse;
  };
  regeneratePasswordRecoveryBridge: {
    request: RegeneratePasswordRecoveryBridgeRequest;
    response: CreatePasswordRecoveryBridgeResponse;
  };
  revokeCustomerSessions: {
    request: RevokeCustomerSessionsRequest;
    response: SuccessOnlyResponse;
  };
  revokePasswordRecoveryBridge: {
    request: RevokePasswordRecoveryBridgeRequest;
    response: SuccessOnlyResponse;
  };
  sendNotificationToCustomer: {
    request: SendClassScheduleNotificationRequest;
    response: SendNotificationResponse;
  };
  setCustomerAuthDisabled: {
    request: SetCustomerAuthDisabledRequest;
    response: SuccessOnlyResponse;
  };
  setCustomerDeveloperAccount: {
    request: SetCustomerDeveloperAccountRequest;
    response: SetCustomerDeveloperAccountResponse;
  };
  setUserCustomClaims: {
    request: UpdateUserCustomClaimsRequest;
    response: SuccessMessageResponse;
  };
  sponsorInfoEditEndDate: {
    request: SponsorInfoEditEndDateRequest;
    response: SuccessMessageResponse;
  };
  syncCustomerToCustomerIo: {
    request: SyncCustomerToCustomerIoRequest;
    response: SyncCustomerToCustomerIoResponse;
  };
  triggerEvidenceDeploy: {
    request: EmptyRequest;
    response: TriggerEvidenceDeployResponse;
  };
  updateCustomerEmail: {
    request: UpdateCustomerEmailRequest;
    response: SuccessMessageResponse;
  };
  updateReferralProgram: {
    request: CreateReferralProgram;
    response: SuccessMessageResponse;
  };
  updateSystemUser: {
    request: UpdateSystemUserRequest;
    response: SuccessMessageResponse;
  };
  upsertConsultant: {
    request: ConsultantUpsertRequest;
    response: ConsultantUpsertResponse;
  };
}

export const adminApiConfig = {
  gatewayName: "admin_default_gateway",
  routes: {
    backfillCustomerAdminListIndex: {
      gateway: "admin_default_gateway",
      action: "backfillCustomerAdminListIndex",
    },
    confirmSponsorshipEligibility: {
      gateway: "admin_default_gateway",
      action: "confirmSponsorshipEligibility",
    },
    createPasswordRecoveryBridge: {
      gateway: "admin_recovery_gateway",
      action: "createPasswordRecoveryBridge",
    },
    createReferralProgram: {
      gateway: "admin_default_gateway",
      action: "createReferralProgram",
    },
    createSystemUser: {
      gateway: "admin_default_gateway",
      action: "createSystemUser",
    },
    deleteSystemUser: {
      gateway: "admin_default_gateway",
      action: "deleteSystemUser",
    },
    editCustomerTrialDates: {
      gateway: "admin_default_gateway",
      action: "editCustomerTrialDates",
    },
    endStaffSession: {
      gateway: "admin_default_gateway",
      action: "endStaffSession",
    },
    generateCustomToken: {
      gateway: "admin_default_gateway",
      action: "generateCustomToken",
    },
    generateCustomTokenForCustomer: {
      gateway: "admin_default_gateway",
      action: "generateCustomTokenForCustomer",
    },
    getCustomerAuthStatus: {
      gateway: "admin_default_gateway",
      action: "getCustomerAuthStatus",
    },
    getSystemUserByEmail: {
      gateway: "admin_default_gateway",
      action: "getSystemUserByEmail",
    },
    getSystemUserByUid: {
      gateway: "admin_default_gateway",
      action: "getSystemUserByUid",
    },
    getUserCustomClaims: {
      gateway: "admin_default_gateway",
      action: "getUserCustomClaims",
    },
    previewSponsorshipEligibility: {
      gateway: "admin_default_gateway",
      action: "previewSponsorshipEligibility",
    },
    reactivateSystemUser: {
      gateway: "admin_default_gateway",
      action: "reactivateSystemUser",
    },
    recalcSponsorEvaluationForCustomer: {
      gateway: "admin_default_gateway",
      action: "recalcSponsorEvaluationForCustomer",
    },
    redeemPasswordRecoveryBridge: {
      gateway: "admin_recovery_gateway",
      action: "redeemPasswordRecoveryBridge",
    },
    refreshPaymentMethodInputsForCustomer: {
      gateway: "admin_default_gateway",
      action: "refreshPaymentMethodInputsForCustomer",
    },
    regeneratePasswordRecoveryBridge: {
      gateway: "admin_recovery_gateway",
      action: "regeneratePasswordRecoveryBridge",
    },
    revokeCustomerSessions: {
      gateway: "admin_default_gateway",
      action: "revokeCustomerSessions",
    },
    revokePasswordRecoveryBridge: {
      gateway: "admin_default_gateway",
      action: "revokePasswordRecoveryBridge",
    },
    sendNotificationToCustomer: {
      gateway: "admin_default_gateway",
      action: "sendNotificationToCustomer",
    },
    setCustomerAuthDisabled: {
      gateway: "admin_default_gateway",
      action: "setCustomerAuthDisabled",
    },
    setCustomerDeveloperAccount: {
      gateway: "admin_default_gateway",
      action: "setCustomerDeveloperAccount",
    },
    setUserCustomClaims: {
      gateway: "admin_default_gateway",
      action: "setUserCustomClaims",
    },
    sponsorInfoEditEndDate: {
      gateway: "admin_default_gateway",
      action: "sponsorInfoEditEndDate",
    },
    syncCustomerToCustomerIo: {
      gateway: "admin_default_gateway",
      action: "syncCustomerToCustomerIo",
    },
    triggerEvidenceDeploy: {
      gateway: "admin_default_gateway",
      action: "triggerEvidenceDeploy",
    },
    updateCustomerEmail: {
      gateway: "admin_default_gateway",
      action: "updateCustomerEmail",
    },
    updateReferralProgram: {
      gateway: "admin_default_gateway",
      action: "updateReferralProgram",
    },
    updateSystemUser: {
      gateway: "admin_default_gateway",
      action: "updateSystemUser",
    },
    upsertConsultant: {
      gateway: "admin_default_gateway",
      action: "upsertConsultant",
    },
  },
} as const satisfies CallableApiConfig<AdminRouteTypeMap>;
